import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  Button,
  Badge,
} from 'react-bootstrap';
import ProposalSendModal from './ProposalSendModal';
import { fromNow } from '../../../core/date';


class ProposalSendMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.send = this.send.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }
  open() {
    this.setState({ showModal: true });
  }
  send() {
    this.handleSubmit({});
  }
  handleSubmit(values) {
    this.props.sendProposal(
      this.props.proposal.id,
      values,
    );
    this.close();
  }
  renderSendNow() {
    if (this.props.proposal.contacts.length > 0 && this.props.status.pending) {
      return (
        <Button id={this.props.proposal.id} bsStyle="info" onClick={this.send} >
          <i
            className="fa fa-envelope"
            aria-hidden="true"
          /> Send Now <Badge>{this.props.status.pending}</Badge>
        </Button>);
    }
    return null;
  }
  renderSentOn() {
    if (this.props.proposal.sent_on) {
      return (
        <p>Bid request sent {fromNow(this.props.proposal.sent_on)}.</p>
      );
    }
    return null;
  }
  render() {
    // No proposal send for non-branded proposals
    if (!this.props.proposal.brand) {
      return null;
    }
    const sendNow = this.renderSendNow();
    const sentOn = this.renderSentOn();
    return (
      <div>
        <ButtonToolbar>
          <Button
            id={this.props.proposal.id}
            bsStyle="info"
            onClick={this.open}
          >
            <i
              className="fa fa-plus"
              aria-hidden="true"
            /> Request Bid
          </Button>
          {sendNow}
        </ButtonToolbar>
        { (this.props.status.pending !== 0) && (
          <p><strong>{this.props.status.pending} requests need to be sent.</strong></p>
        )}
        {sentOn}
        {this.state.showModal && (
          <ProposalSendModal
            proposal={this.props.proposal}
            show={this.state.showModal}
            close={this.close}
            sendProposal={this.props.sendProposal}
          />
        )}
      </div>
    );
  }
}


ProposalSendMenu.propTypes = {
  proposal: PropTypes.object.isRequired,
  sendProposal: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
};

ProposalSendMenu.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default ProposalSendMenu;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalSendMenu.js